angular.module('iqxCore')
.controller('OwnerDashboardCtrl', function ($scope, $document, FormSvc, ApiSvc, ApplicationSvc, $window, $q, $timeout, $routeParams, Upload, toastSvc) {
  $scope.checkPermissions('OWNER')
  $scope.theForm={}
  $scope.theRecord={}
  
  function eu(s){
    return encodeURIComponent(s)
  }

  $scope.displayDashboard=function(){
    ApplicationSvc.navigate('/dashboard?action=dashboard')
  }


  $scope.uploadSelect=function(files,file,event) {
    // $scope.theForm.file.$touched=true  // Show any validation error on the selected file
    return
    }
    
  $scope.uploadCleanup=function() {
    // $scope.reset()
    $scope.uploadProgress=''
    $scope.uploadError=''
    $scope.theRecord={}
    $scope.tags=[]
    $scope.uploadFileName()
    }
  
  $scope.uploadFileName=function() {
    if ($scope.theRecord.file) {
      return $scope.theRecord.file.name
     } else {
      return 'Select *.iqx-graph file..'
     }
    }
    
  $scope.showUploadProgress=function(evt) {
    var s='Uploading...'
    if (evt && evt.total) {  // progress callback
      s=s + parseInt(100.0 * evt.loaded / evt.total) + '%'
      }
    $scope.uploadProgress=s
    }

  $scope.uploadExecute=function() {
    var reader = new FileReader()
    $scope.setSubmitted(true) // Ensure all validation errors appear
    if ($scope.uploadProgress || $scope.theForm.$invalid) {return}
        $scope.uploadError=''
        $scope.showUploadProgress()
        Upload.dataUrl($scope.theRecord.file, true)
        .then(function(blob) {
          blob = blob.replace("data:;base64,","")
          blob = atob(blob)
          blob = JSON.parse(blob)
          $scope.doImport(blob)
        })
        .then(function(){
          $scope.uploadProgress='Upload complete'
        })
        .then(function(){
          $scope.setEditing(false)
          $scope.uploadCleanup()
        })
  }

  $scope.doImport=function(obj){
    var saveObj={
      pType:obj.Type,
      pTitle:obj.Title,
      pDescriptor:JSON.stringify(obj.Descriptor),
      pShared: (obj.Shared ? 1 : 0),
      pAccessLevel: obj.AccessLevel,
      pDashboard: (obj.OnDashboard ? 1 : 0),
      pHomePage: (obj.OnHomePage ? 1 : 0)
    }
    return $scope.exec('call/NetDashboardObjectSet',saveObj)
    .then(function(){
      $scope.fetchList()
    })
  }

  $scope.exportObject = function(obj){
        var objC=angular.copy(obj)
        delete objC.DashboardObjectID
        delete objC.UserName
        objC.Descriptor = JSON.parse(objC.Descriptor)
        var filename = objC.Title.replace(/[^a-z0-9]/gi, '_').toLowerCase()+".iqx-graph"
        var blob = new Blob([JSON.stringify(objC)], {type: 'text/text'})
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else{
            var e = document.createEvent('MouseEvents'),
            a = document.createElement('a')
            a.download = filename
            a.href = window.URL.createObjectURL(blob)
            a.dataset.downloadurl = ['application/json', a.download, a.href].join(':')
            e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            a.dispatchEvent(e)
        }
    }

  $scope.designObject=function(obj){
    if(obj.newObject){
      ApplicationSvc.navigate('/dashboard?action=design&new='+encodeURIComponent(obj.newObject))
    } else if(obj.DashboardObjectID){
      ApplicationSvc.navigate('/dashboard?action=design&object='+encodeURIComponent(obj.DashboardObjectID))
    }
  }
  
  $scope.viewObject=function(obj){
    if(obj.DashboardObjectID){
      ApplicationSvc.navigate('/dashboard?action=display&object='+encodeURIComponent(obj.DashboardObjectID))
    }
  }
  
  $scope.saveObject=function(){
    $scope.modalCaption='Save Object'
    FormSvc.modalForm($scope,'getChartCaption',{chartCaption:$scope.chartObject.chartOptions.title.text,label:'Description'},'md',{label:'col-xs-12 text-left', data:'col-xs-12'})
    .then(function(data){
      var obj={queries:$scope.queries}
      if ($scope.chartObject.objectType=='Performance Chart') {
        obj.range=$scope.dateSelection.range.id
        obj.granularity=$scope.dateSelection.granularity.id
        if($scope.chartObject.chartHeight){obj.chartHeight=$scope.chartObject.chartHeight}
      } else if ($scope.chartObject.objectType=='Analysis Chart') {
        obj.grouping=$scope.anlGrps.groupings[$scope.anlGrps.grouping]
        obj.chartType=$scope.chartObject.chartType
        if($scope.chartObject.chartHeight){obj.chartHeight=$scope.chartObject.chartHeight}
      }
      var saveObj={pType:$scope.chartObject.objectType,pTitle:data.chartCaption,pDescriptor:JSON.stringify(obj)}
      if($scope.chartObject.ID){saveObj.pDashboardObjectID=$scope.chartObject.ID}
      $scope.exec('call/NetDashboardObjectSet',saveObj)
      .then(function(){
        ApplicationSvc.navigate('/dashboard?action=list')
      })
    })
  }
  
  $scope.updateDashboard=function(obj){
    $scope.exec('call/NetDashboardObjectSet',{pDashboardObjectID:obj.DashboardObjectID,pDashboard:obj.OnDashboard?1:0})
  }

  $scope.updateHomePage=function(obj){
    $scope.exec('call/NetDashboardObjectSet',{pDashboardObjectID:obj.DashboardObjectID,pHomePage:obj.OnHomePage?1:0})
  }

  $scope.updateShared=function(obj){
    var prom,acc
    if (obj.Shared){
      prom=FormSvc.modalForm($scope,'getChartAccessLevel',{accessLevel:obj.AccessLevel},'sm',{label:'col-xs-12 text-left', data:'col-xs-12'})
    } else {
      prom=$q.when({accessLevel:obj.AccessLevel})
    }
    prom.then(function(data){
      acc=data.accessLevel || 0
      return $scope.exec('call/NetDashboardObjectSet',{pDashboardObjectID:obj.DashboardObjectID,pShared:obj.Shared?1:0,pAccessLevel:acc})
    })
    .then(function(){
      obj.AccessLevel=acc
    })
    .catch(function(){  // Revert the tick
      obj.Shared=!obj.Shared
    })
  }

  $scope.renameObject=function(obj){
    var newTitle
    $scope.modalCaption='Rename Object'
    FormSvc.modalForm($scope,'getChartCaption',{chartCaption:obj.Title,label:'New Description'},'md',{label:'col-xs-12 text-left', data:'col-xs-12'})
    .then(function(data){
      newTitle=data.chartCaption
      return $scope.exec('call/NetDashboardObjectSet',{pDashboardObjectID:obj.DashboardObjectID,pTitle:newTitle})
    })
    .then(function(){
      obj.Title=newTitle
    })
  }

  $scope.copyObject=function(obj){
    $scope.modalCaption='Copy Object'
    FormSvc.modalForm($scope,'getChartCaption',{chartCaption:obj.Title,label:'Description for Copy'},'md',{label:'col-xs-12 text-left', data:'col-xs-12'})
    .then(function(data){
      return $scope.exec('call/NetDashboardObjectSet',{pType:obj.Type,pTitle:data.chartCaption,pDescriptor:obj.Descriptor})
    })
    .then(function(){
      $scope.fetchList()
    })
  }

  $scope.deleteObject=function(obj){
    ApplicationSvc.queryMessage('Delete Object','Delete '+obj.Title+' - are you sure?')
    .then(function(){
      return $scope.exec('call/NetDashboardObjectSet',{pDashboardObjectID:obj.DashboardObjectID,pType:'DELETE'})
    })
    .then(function(){
      $scope.fetchList()
    })
  }

  $scope.setupDesignForm=function(){
    $scope.filterChoices={}
    $scope.classes={label:'col-sm-4', data:'col-sm-4'}
    $scope.dateRanges=[ // Need to add things like year to date, current month and future dates
      {id:'30',description:'30 days'},
      {id:'60',description:'60 days'},
      {id:'90',description:'90 days'},
      {id:'183',description:'6 months'},
      {id:'365',description:'1 year'},
      {id:'730',description:'2 years'},
      {id:'1096',description:'3 years'},
      {id:'1826',description:'5 years'},
      {id:'3652',description:'10 years'},
    ]
    $scope.dateFilters=[ // Need to add things like year to date, current month and future dates
      {id:'30',description:'in last 30 days'},
      {id:'60',description:'in last 60 days'},
      {id:'90',description:'in last 90 days'},
      {id:'183',description:'in last 6 months'},
      {id:'365',description:'in last 12 months'},
      {id:'730',description:'in last 2 years'},
      {id:'1096',description:'in last 3 years'},
      {id:'1826',description:'in last 5 years'},
      {id:'3652',description:'in last 10 years'},
      {id:'',description:'Other'},
    ]
    $scope.dateGranularities=[
      {id:'d',description:'Day'},
      {id:'w',description:'Week'},
      {id:'m',description:'Month'},
      {id:'q',description:'Quarter'},
      {id:'y',description:'Year'},
    ]
    $scope.chartTypes=[
      {id:'line',description:'Line'},
      {id:'bar',description:'Vertical Bar'},
      {id:'horizontalBar',description:'Horizontal Bar'},
      {id:'radar',description:'Radar'},
    ]
    var sizes=[300,700,1500,3000,4500,6000]
    $scope.chartSizes=sizes.map(function(x){return {id:x+'px',description:x+' pixels'}})
    $scope.chartSizes.unshift({id:'',description:'Auto'})
  }
  
  $scope.createChartDefaults=function(){
    Chart.scaleService.updateScaleDefaults('linear', {  // Defaults for all linear scales
      ticks: {
        beginAtZero: true,
        suggestedMax: 5
      }
    })
    
    $scope.chartDefaults={}
    $scope.chartDefaults.axisTime={
      type: "time",
      time: {
        //unit: 'day',
        round: 'day',
        tooltipFormat: 'DD/MM/YYYY'
      },
      display: true,
      scaleLabel: {
        display: true,
        labelString: 'Date'
      }
    }
    $scope.chartDefaults.axisValue={
      id: 'Value',
      position: 'left',
      display: false,
      ticks: {
        beginAtZero: true
      },
      scaleLabel: {
        display: true,
        labelString: 'Value'
      }
    }
    $scope.chartDefaults.axisCount={
      id: 'Count',
      position: 'left',
      display: false,
      ticks: {
        beginAtZero: true,
        suggestedMax: 5,  // Count scale of just 0 and 1 looks silly
        callback: function(val){return (val % 1)?undefined:val}  // Suppresses labels and grid lines for non-integer values
      },
      scaleLabel: {
        display: true,
        labelString: 'Count'
      }
    }
    $scope.chartDefaults.chartOptions = {
      responsive: true,
      maintainAspectRatio: true,
      title:{
          display:true,
          text:''
      },
      legend:{
        display:true,
        position:'right'
      }
    }
    $scope.chartDefaults.chartColours=['blue','green','red','yellow','purple','lime','fuchsia','aqua','olive','orange','teal','navy','maroon','gray']
  }
  
  $scope.setupChartOptions=function(obj){
    var src=obj || $scope.theRecord
    obj=obj || $scope
    if(src.Descriptor){
      if(angular.isString(src.Descriptor)){  // May have been parsed already
        try {
          src.Descriptor=JSON.parse(src.Descriptor)
        } catch(err){
          src.Descriptor={}
        }
      }
    } else {
      src.Descriptor={}
    }
    obj.chartObject={objectType:src.Type}
    if(src.Type=='Analysis Chart'){
      obj.chartObject.chartType=src.Descriptor.chartType || 'horizontalBar'
      obj.chartObject.chartHeight=src.Descriptor.chartHeight || ''
      obj.chartObject.selGrphHeight=obj.chartObject.chartHeight
    } else {
      obj.chartObject.chartType='line'
      obj.chartObject.chartHeight=src.Descriptor.chartHeight || ''
      obj.chartObject.selGrphHeight=obj.chartObject.chartHeight
    }
    obj.chartObject.axisTime=angular.copy($scope.chartDefaults.axisTime)
    obj.chartObject.axisValue=angular.copy($scope.chartDefaults.axisValue)
    obj.chartObject.axisCount=angular.copy($scope.chartDefaults.axisCount)
    obj.chartObject.chartOptions=angular.copy($scope.chartDefaults.chartOptions)
    obj.chartObject.chartColours=angular.copy($scope.chartDefaults.chartColours)
    obj.chartObject.chartTitle=src.Title || ''
    obj.chartObject.chartOptions.title.text=obj.chartObject.chartTitle
    obj.chartObject.chartOptions.maintainAspectRatio=obj.chartObject.chartHeight?false:true   // '' means default where maintainAspectRatio should be true
    obj.chartObject.ID=src.DashboardObjectID || ''
    obj.chartObject.index=''
  }
  
  $scope.selGrphHeightChange=function(){
    $scope.chartObject.chartData=undefined
    $timeout()  // This makes angular destroy and re-create the canvas. Re-drawing the graph on its own doesn't work properly
    .then(function(){
      $scope.chartObject.chartHeight=$scope.chartObject.selGrphHeight
      $scope.chartObject.chartOptions.maintainAspectRatio=$scope.chartObject.chartHeight?false:true   // '' means default where maintainAspectRatio should be true
      $scope.chartObject.chartData=$scope.chartObject.chartData1
    })
  }
  
  $scope.endOfRange=function(dt,granularity){
    switch(granularity){
      case 'd': return dt
      case 'w': return moment(dt).add(6,'days').toDate()
      case 'm': return moment(dt).endOf('month').toDate()
      case 'q': return moment(dt).endOf('quarter').toDate()
      case 'y': return moment(dt).endOf('year').toDate()
    }
  }
  
  $scope.zoomGranularity=function(granularity){
    switch(granularity){  // zoom in 2 steps
      case 'y': return 'm'
      case 'q': return 'w'
      default: return 'd'
    }
  }

  $scope.fetchDictionary=function(){
    if($scope.dictionary){return $q.when('')} // Already fetched
    return $scope.fetch({fetchAPI:'olap/dictionary',fetchTarget:'dictionary',multiRow:true})
  }
  
  $scope.fetchDrilldowns=function(){
    if($scope.drilldowns){return $q.when('')} // Already fetched
    return $scope.fetch({fetchAPI:'callresult/NetDashboardObjects?pAll=1',fetchTarget:'drilldowns',multiRow:true})
  }
  
  $scope.fetchList=function(){
    return $scope.fetch({fetchAPI:'callresult/NetDashboardObjects?pAll=1',booleanFields:['Shared','OnDashboard','OnHomePage'],multiRow:true})
  }
  
  $scope.loadTree=function(){
    if ($scope.chartObject.objectType=='Performance Chart') {
      $scope.setupPerformanceTree()
    } else if ($scope.chartObject.objectType=='Analysis Chart') {
      $scope.setupAnalysisTree()
    }
  }
  
  $scope.setupAnalysisTree=function(){
    var savedGrouping=''
    if($scope.theRecord.Descriptor){  
      savedGrouping=$scope.theRecord.Descriptor.grouping
    }
    $scope.data=[]
    $scope.tableMap={}
    $scope.anlStats={type:'anlStatistics',caption:'Statistics',nodes:[]}
    $scope.anlGrps={type:'anlGroupings',caption:'Analyse by',nodes:[],groupings:[],grouping:-1,loadedGrouping:-2}
    var grpIx=0;
    $scope.data.push($scope.anlGrps)
    $scope.data.push($scope.anlStats)
    angular.forEach($scope.dictionary,function(x){
      $scope.tableMap[x.table]=x
      var xx={type:'anlTable',caption:x.table,object:x,nodes:[]}
      angular.forEach(x.groupings, function(g){
        xx.nodes.push({type:'grouping',caption:g,nodes:[],checkbox:false,index:grpIx++,parent:$scope.anlGrps})
        g=x.table+'_'+g
        $scope.anlGrps.groupings.push(g)
        if(g==savedGrouping){
          xx.collapsed=false
        }
      })
      if (xx.nodes.length){
        $scope.anlGrps.nodes.push(xx)
      }
    })
    if($scope.theRecord.Descriptor){  
      $scope.anlGrps.grouping=$scope.anlGrps.groupings.indexOf($scope.theRecord.Descriptor.grouping)
      if($scope.anlGrps.grouping>=0){
        $scope.setupAnalysisStats()
      }
    }
  }
  
  $scope.stripTableName=function(s){
    var i=s.indexOf('_')
    if(i>=0){
      return s.substr(i+1)
    } else {
      return s
    }
  }
  
  $scope.findQuery=function(tbl){
    var query
    angular.forEach($scope.theRecord.Descriptor.queries,function(q){  // First find the right query
      if(q.table==tbl.table){query=q}
    })
    return query
  }
  
  $scope.savedStatistics=function(tbl){
    var stats={}
    if($scope.theRecord.Descriptor){
      var query=$scope.findQuery(tbl)
      if(query){
        angular.forEach(query.statistics,function(stat){
          if(tbl.statistics.indexOf($scope.stripTableName(stat))>=0){  // Check that the stat is still valid
            stats[stat]=true
          }
        })
      }
    }
    return stats
  }
  
  $scope.findDrilldown=function(id){
    var rv=null
    if($scope.drilldowns){
      angular.forEach($scope.drilldowns,function(dd){
        if(dd.DashboardObjectID==id){
          rv=dd
        }
      })
    }
    return rv
  }
  
  $scope.savedDrilldowns=function(tbl){
    var dds={}
    if($scope.theRecord.Descriptor){
      var query=$scope.findQuery(tbl)
      if(query){
        angular.forEach(query.drilldowns,function(ddID){
          if($scope.findDrilldown(ddID)){  // Check that the drilldown still exists
            dds[ddID]=true
          }
        })
      }
    }
    return dds
  }
  
  $scope.savedTiming=function(tbl){
    var tim=0
    if($scope.theRecord.Descriptor){
      var query=$scope.findQuery(tbl)
      if(query && query.timing){
        tim=tbl.timings.indexOf(query.timing)
        if(tim<0){tim=0}  // Not found - use default
      }
    }
    return tim
  }
  
  $scope.savedGrouping=function(tbl){
    var grp=''
    if($scope.theRecord.Descriptor){
      var query=$scope.findQuery(tbl)
      if(query && query.grouping){
        grp=query.grouping
      }
    }
    return grp
  }
  
  $scope.savedDateSelection=function(){
    var res={}
    if($scope.theRecord.Descriptor){
      res.range=$scope.dateRanges.find(function(x){return (x.id==$scope.theRecord.Descriptor.range)}) || $scope.dateRanges[0]
      res.granularity=$scope.dateGranularities.find(function(x){return (x.id==$scope.theRecord.Descriptor.granularity)}) || $scope.dateGranularities[0]
    }
    return res
  }
  
  $scope.setupAnalysisStats=function(){
    if($scope.anlGrps.grouping==$scope.anlGrps.loadedGrouping){return}
    $scope.anlGrps.loadedGrouping=$scope.anlGrps.grouping
    $scope.anlStats.nodes=[]
    var grp=$scope.anlGrps.groupings[$scope.anlGrps.grouping]    
    var i=grp.indexOf('_')
    var grpTbl=grp.substr(0,i)
    var grpFld=grp.substr(i+1)
    angular.forEach($scope.dictionary,function(x){
      x.filterBehaviour=x.filterBehaviour || {}
      if (x.table==grpTbl || (x.joinedTables && x.joinedTables.indexOf(grpTbl)>=0) || (x.commonGroupings && x.commonGroupings.indexOf(grpFld)>=0)) {
        var savedStats=$scope.savedStatistics(x)
        var xx={type:'anlTable',caption:x.table,object:x,nodes:[],grouping:0,statistics:savedStats,groupings:['None'],filters:{},drilldowns:$scope.savedDrilldowns(x),collapsed:angular.equals(savedStats,{})}
        angular.forEach(x.statistics, function(s){
          xx.nodes.push({type:'statistic',caption:s,nodes:[],checkbox:true,parent:xx,cbID:x.table+'_'+s})
        })
        if (xx.nodes.length){
          $scope.addFilters(xx,true)
          $scope.addGroupings(xx,grp)
          $scope.addDrilldowns(xx)
          $scope.anlStats.nodes.push(xx)
        }
      }
    })
  }
  
  $scope.setupPerformanceTree=function(){
    $scope.data=[]
    $scope.tableMap={}
    angular.forEach($scope.dictionary,function(x){
      x.filterBehaviour=x.filterBehaviour || {}
      $scope.tableMap[x.table]=x
      if (x.timings && x.timings.length && x.statistics && x.statistics.length) { // This is for Performance Chart. Analysis Chart will not require the timings
        var xx={type:'table',caption:x.table,object:x,nodes:[],timing:$scope.savedTiming(x),grouping:0,statistics:$scope.savedStatistics(x),groupings:['None'],filters:{},drilldowns:$scope.savedDrilldowns(x),}
        $scope.data.push(xx)
        $scope.addPerfStatistics(xx)
        $scope.addPerfTimings(xx)
        $scope.addFilters(xx)
        $scope.addGroupings(xx)
        $scope.addDrilldowns(xx)
        }
    })
    $scope.dateSelection=$scope.savedDateSelection()
    $scope.data.push({type:'dateSelection',caption:'Date Selection',nodes:[{type:'dateRange',caption:'Range',nodes:[]},{type:'dateGranularity',caption:'Round to Nearest',nodes:[]}]})
  }
  
  $scope.addDrilldowns=function(node){
    if(!$scope.drilldowns){return}
    var sels=[]
    angular.forEach(node.drilldowns,function(val,key){
      if(val){
        angular.forEach($scope.drilldowns,function(val){
          if(val.DashboardObjectID==key){
            sels.push(val.Title)
          }
        })
      }
    })
    var cap='Drilldowns'
    if (sels.length){
      cap+=': '+sels.join(', ')
    }
    node.nodes.push({type:'drilldowns',caption:cap,nodes:[],parent:node})
  }
  
  $scope.addPerfStatistics=function(node){
    var xs=[]
    var ix=0
    angular.forEach(node.object.statistics, function(x){
      xs.push({type:'statistic',caption:x,nodes:[],checkbox:true,index:ix++,parent:node,cbID:node.object.table+'_'+x})
    })
    if(xs.length){
      node.nodes.push({type:'statistics',caption:'Statistics',nodes:xs,collapsed:false})
    }
  }
  
  $scope.addPerfTimings=function(node){
    var xs=[]
    var ix=0
    angular.forEach(node.object.timings, function(x){
      xs.push({type:'timing',caption:x,nodes:[],checkbox:false,index:ix++,parent:node,cbID:node.object.table+'_'+x})
    })
    if(xs.length){
      node.nodes.push({type:'timings',caption:'Date',nodes:xs,collapsed:false})
    }
  }
  
  $scope.addGroupings=function(node,analysisGrp){
    var xs=[]
    var ix=1  // 0:None option is already present
    var id
    var savedGrouping=$scope.savedGrouping(node.object)
    var analysisGrpFld,commonGroupings
    if(analysisGrp){
      var i 
      i=savedGrouping.indexOf(',')
      if(i<0){  // There is no split. savedGrouping contains the main analysis grouping only (or nothing if not yet saved)
        savedGrouping=''
      } else {  // Strip off the main analysis grouping to leave the split
        savedGrouping=savedGrouping.substr(0,i)
      }
      i=analysisGrp.indexOf('_')
      analysisGrpFld=analysisGrp.substr(i+1)
      commonGroupings=$scope.tableMap[analysisGrp.substr(0,i)].commonGroupings
    }
    angular.forEach(node.object.groupings, function(x){
      id=node.object.table+'_'+x
      if(id == analysisGrp || (commonGroupings && x==analysisGrpFld && (commonGroupings.indexOf(x)>=0) )) {
        return  // Exclude main analysis grouping from sub-split choices
      }
      if(id==savedGrouping){node.grouping=ix}
      xs.push({type:'grouping',caption:x,nodes:[],checkbox:false,index:ix++,parent:node})
      node.groupings.push(id)
    })
    angular.forEach(node.object.joinedTables, function(y){
      var nodeGroupingSnapshot=node.grouping
      var xt=[]
      angular.forEach($scope.tableMap[y].groupings, function(z){
        id=y+'_'+z
        if(id == analysisGrp || (commonGroupings && z==analysisGrpFld && (commonGroupings.indexOf(z)>=0) )) {
          return // Exclude main analysis grouping from sub-split choices
        }
        if(id==savedGrouping){node.grouping=ix}
        xt.push({type:'grouping',caption:z,nodes:[],checkbox:false,index:ix++,parent:node})
        node.groupings.push(id)
      })
      if(xt.length){
        xs.push({type:'joinedTableSplits',caption:y,nodes:xt,collapsed:(node.grouping===nodeGroupingSnapshot)})
      }
    })
    if(xs.length){
      xs.unshift({type:'grouping',caption:'None',nodes:[],checkbox:false,index:0,parent:node})  // The 'None' option
      node.nodes.push({type:'groupings',caption:'Split',nodes:xs,collapsed:(node.grouping===0)})
    }
  }
  
  $scope.addFilters=function(node,defaultDateFilter){
    var xs=[]
    var activeCount=0
    var savedFilters
    if($scope.theRecord.Descriptor){
      defaultDateFilter=false // Only applies to new objects
      angular.forEach($scope.theRecord.Descriptor.queries,function(q){  // Find the right query
        if(q.table==node.object.table){savedFilters=q.filters}
      })
    }
    function add1Filter(ar,type,tbl,caption) {
      var id=tbl+'_'+caption
      var descrip=''
      if(savedFilters && savedFilters[id]){
        activeCount++
        var f=savedFilters[id]
        descrip=f.description || ''
        if(f.fromDate){f.fromDate=moment(f.fromDate,'YYYY-MM-DD').toDate()}
        if(f.toDate){f.toDate=moment(f.toDate,'YYYY-MM-DD').toDate()}
        if(f.choices){
          var newChoices={}
          newChoices.__tick__choices__=f.choices.map(function(c){return {Value:c}})  // Will be replaced if they edit this filter, otherwise it is required for extracting the filter value
          angular.forEach(f.choices,function(c){
            newChoices[c]=true
          })
          node.filters[id]=newChoices
        } else {
          node.filters[id]=f
        }
        node.filters[id].__filter__type__=f.type  // Required for extracting filter value if they don't edit it
        node.filters[id].__filter__description__=descrip
      }
      if(defaultDateFilter && type=='Date'){  // This default is to prevent accidentally searching the entire database
        activeCount++
        descrip=$scope.dateFilters[0].description
        node.filters[id]={__filter__type__:'Date', __filter__description__:descrip, dateRange:$scope.dateFilters[0].id}
        defaultDateFilter=false
      }
      ar.push({type:'filter',filterType:type,caption:caption,nodes:[],parent:node,cbID:id,value:descrip})
    }
    angular.forEach(node.object.groupings, function(x){
      add1Filter(xs,node.object.filterBehaviour[x] || 'Text',node.object.table,x)
    })
    angular.forEach(node.object.filters, function(x){
      add1Filter(xs,node.object.filterBehaviour[x] || 'Text',node.object.table,x)
    })
    angular.forEach(node.object.timings, function(x){
      add1Filter(xs,node.object.filterBehaviour[x] || 'Date',node.object.table,x)
    })
    angular.forEach(node.object.joinedTables, function(y){
      var activeCountSnapshot=activeCount
      var xt=[]
      angular.forEach($scope.tableMap[y].groupings, function(z){
        add1Filter(xt,$scope.tableMap[y].filterBehaviour[z] || 'Text',y,z)
      })
      angular.forEach($scope.tableMap[y].filters, function(z){
        add1Filter(xt,$scope.tableMap[y].filterBehaviour[z] || 'Text',y,z)
      })
      angular.forEach($scope.tableMap[y].timings, function(z){
        add1Filter(xt,$scope.tableMap[y].filterBehaviour[z] || 'Date',y,z)
      })
      if(xt.length){
        xs.push({type:'joinedTableFilters',caption:y,nodes:xt,collapsed:(activeCount===activeCountSnapshot)})
      }
    })
    if(xs.length){
      node.nodes.push({type:'filters',caption:'Filters',nodes:xs,collapsed:(activeCount===0)})
    }
  }
  
  $scope.nodeFilterDescription=function(node){
    var activeFilters=[]
    angular.forEach(node.nodes,function(subNode){
      if (subNode.type=='filters'){
        angular.forEach(subNode.nodes,function(filterNode){
          if(filterNode.type=='filter'){
            if(filterNode.value){
              activeFilters.push(filterNode.caption+' '+filterNode.value)
            }
          } else if (filterNode.type=='joinedTableFilters'){
            angular.forEach(filterNode.nodes,function(subFilterNode){
              if(subFilterNode.value){
                activeFilters.push(filterNode.caption+' '+subFilterNode.caption+' '+subFilterNode.value)
              }
            })
          }
        })
      }
    })
    if(activeFilters.length){
      return ' where '+activeFilters.join(' and ')
    } else {
      return ''
    }
  }
  
  $scope.nodeState=function(node){
    if (node.type=='table'){
      var stats=[]
      angular.forEach(node.statistics,function(val,key){
        if (val) {
          stats.push($scope.stripTableName(key))
        }
      })
      if (stats.length){
        return ': '+stats.join(', ')+' by '+node.object.timings[node.timing]+(node.grouping?', '+node.groupings[node.grouping].replace('_',' '):'') + $scope.nodeFilterDescription(node)
      }
    } else if (node.type=='anlGroupings'){
      if ($scope.anlGrps.grouping>=0) {
        return ': '+$scope.anlGrps.groupings[$scope.anlGrps.grouping].replace('_',' ')
      }
    } else if (node.type=='anlStatistics'){
      var stats=[]
      angular.forEach($scope.anlStats.nodes,function(tbl){
        var tblStats=[]
        angular.forEach(tbl.statistics,function(val,key){
          if (val) {
            tblStats.push(key)
          }
        })
        if(tblStats.length){
          stats.push(tblStats.join(', ').replace(/_/g,' ') + (tbl.grouping?' by '+tbl.groupings[tbl.grouping].replace('_',' '):'') + $scope.nodeFilterDescription(tbl))
        }
      })
      if (stats.length){
        return ': '+stats.join(', ')
      }
    } else if (node.type=='dateSelection'){
      return ': '+$scope.dateSelection.range.description+' by '+$scope.dateSelection.granularity.description
    } else if (node.type=='filter'){
      if (node.value.trim()) {
        return ': '+node.value
      }
    }
  }
  
  $scope.getFilterValue=function(node){
    // Put value object in node.parent.filters[node.cbID] and value descriptive text in node.value
    node.parent.filters[node.cbID]=node.parent.filters[node.cbID] || {}  // Ensure has value container object
    function getChoices(){
      if ((node.filterType=='SingleID' || node.filterType=='MultiID') && !$scope.filterChoices[node.cbID]){
        return $scope.fetch({fetchAPI:'olap/choicelist?id='+eu(node.cbID),fetchTarget:'tempChoiceList',multiRow:true})
        .then(function(){
          $scope.filterChoices[node.cbID]=$scope.tempChoiceList
          $scope.tempChoiceList=undefined
        })
      } else {
        return $q.when('') // No fetch required
      }
    }
    var dlg=''
    var fmt={label:'col-sm-3', data:'col-sm-7'}
    var sz='md'
    var data=node.parent.filters[node.cbID]
    data.__filter__type__=node.filterType
    getChoices()
    .then(function(){
      switch(node.filterType){  
        case 'Text':
        case 'TextChoice':
          dlg='filterPlainText'
          fmt={label:'col-xs-12 text-left', data:'col-xs-12'}
          break
        case 'Date':
          dlg='filterDateChoice'
          data.__date__ranges__=$scope.dateFilters
          data.dateRange=data.dateRange || ''
          break
        case 'Number':
          dlg='filterNumberRange'
          break
        case 'SingleID':
        case 'MultiID':
          dlg='filterTickList'
          fmt={label:'col-xs-9', data:'col-xs-1'}
          sz='md'  // Was sm but goes messy if any long descrips
          data.__tick__choices__=$scope.filterChoices[node.cbID]
          break
        default: return   // Unknown type
      }
      $scope.filterDlgCaption=node.cbID.replace(/_Name$/,'').replace('_',' ')
      var newData=angular.copy(data)  // This copy is discarded if the dialog is cancelled
      FormSvc.modalForm($scope,dlg,newData,sz,fmt)
      .then(function(data){
        node.parent.filters[node.cbID]=data  // Point to new object
        switch(node.filterType){  
          case 'Text':
          case 'TextChoice':
            node.value=data.textValue
            break
          case 'Date':
            if(data.dateRange){
              var dFilt=$scope.dateFilters.find(function(x){return (x.id==data.dateRange)}) || $scope.dateFilters[0]
              node.value=dFilt.description
            } else {
              node.value=data.fromDate?('from '+moment(data.fromDate).format('DD/MM/YYYY')):''
              node.value=node.value+(data.toDate?(' to '+moment(data.toDate).format('DD/MM/YYYY')):'')
            }
            break
          case 'Number':
            node.value=isFinite(data.fromNumber)?('from '+data.fromNumber.toString()):''
            node.value=node.value+(isFinite(data.toNumber)?(' to '+data.toNumber.toString()):'')
            break
          case 'SingleID':
          case 'MultiID':
            var sels=[]
            angular.forEach(data.__tick__choices__,function(choice){
              if(data[choice.Value]){
                sels.push(choice.Description)
              }
            })
            node.value=sels.join(', ')
            break
        }
        data.__filter__description__=node.value  // This is used for saving purposes, mainly so that descriptive choices can be displayed without having to retrieve the full choice list
      })
    })
  }
  
  $scope.cleanFilterValue=function(filters){
    var cleanFilters={}
    angular.forEach(filters,function(filter,ix){
      var cln={}
      switch(filter.__filter__type__){  
        case 'Text':
        case 'TextChoice':
          if(filter.textValue && filter.textValue.trim()) {cln.textValue=filter.textValue.trim()}
          break
        case 'Date':
          if(filter.dateRange){
            cln.dateRange=filter.dateRange
          } else {
            if(filter.fromDate){cln.fromDate=moment(filter.fromDate).format('YYYY-MM-DD')}
            if(filter.toDate){cln.toDate=moment(filter.toDate).format('YYYY-MM-DD')}
          }
          break
        case 'Number':
          if(isFinite(filter.fromNumber)){cln.fromNumber=filter.fromNumber}
          if(isFinite(filter.toNumber)){cln.toNumber=filter.toNumber}
          break
        case 'SingleID':
        case 'MultiID':
          var choices=[]
          angular.forEach(filter.__tick__choices__,function(choice){
            if(filter[choice.Value]){
              choices.push(choice.Value)
            }
          })
          if(choices.length){
            cln.choices=choices
          }
          break
      }
      if(!angular.equals(cln,{})){
        cln.type=filter.__filter__type__
        cln.description=filter.__filter__description__
        cleanFilters[ix]=cln
      }
    })
    return cleanFilters
  }
  
  $scope.getDrilldowns=function(node){
    // Update node.parent.drilldowns and put descriptive text in node.value
    var dlg='getDrilldowns'
    var fmt={label:'col-xs-9', data:'col-xs-1'}
    var sz='md'  
    var data=node.parent.drilldowns
    var newData=angular.copy(data)  // This copy is discarded if the dialog is cancelled
    newData.__tick__choices__=$scope.drilldowns
    FormSvc.modalForm($scope,dlg,newData,sz,fmt)
    .then(function(data){
      delete data.__tick__choices__
      node.parent.drilldowns=data  // Point to new object
      var sels=[]
      angular.forEach($scope.drilldowns,function(choice){
        if(data[choice.DashboardObjectID]){
          sels.push(choice.Title)
        }
      })
      node.caption='Drilldowns' + (sels.length?(': '+sels.join(', ')):'')
    })
  }
  
  $scope.expander=function(node,x,event){
    //'this' items: expand() toggle() collapse() collapsed $modelValue
    if(event){event.stopPropagation()}
    
    switch(node.type){  // Clicking anywhere on the tree node can activate the radio or checkbox click
      case 'statistic':
        node.parent.statistics[node.cbID]=!node.parent.statistics[node.cbID]
        break
      case 'drilldowns':
        $scope.getDrilldowns(node)
        break
      case 'timing':
        node.parent.timing=node.index
        break
      case 'grouping':
        node.parent.grouping=node.index
        break
      case 'filter':
        $scope.getFilterValue(node)
        break
    }

    x.toggle()  // expanded <-> collapsed
    
    if ((node.type=='table' || node.type=='anlGroupings' || node.type=='anlStatistics' || node.type=='dateSelection') && !node.scope){
      node.scope=x  // Will be used for programmatically collapsing to tidy up on Execute
    }
    
    if (node.type=='grouping' && $scope.chartObject.objectType=='Analysis Chart'){  // Load the stats tables available for the selected grouping
      $scope.setupAnalysisStats()
    }
  }
  
  $scope.execute=function(obj){
    var chartObject=obj?obj.chartObject:$scope.chartObject
    if (chartObject.objectType=='Performance Chart') {
      $scope.executePerformance(obj)
    } else {
      $scope.executeAnalysis(obj)
    }
  }
  
// Create Analysis Chart  
  
  $scope.executeAnalysis=function(obj){
    var scope=obj?obj:$scope
    var chartObject=scope.chartObject
    var descriptor=obj?obj.Descriptor:$scope.theRecord.Descriptor
    var chartCharacter={tables:0,nonCountStats:0}  // chartCharacter determines whether table names and stat names appear on the legend
    scope.formError=''
    chartObject.chartData = undefined
    chartObject.chartData1 = {labels: [], datasets: []}
    chartObject.chartOptions.scales={}
    if($window.innerWidth<1028){
      chartObject.chartOptions.legend.position='bottom'
    }
    scope.grphLoading=true
    if(descriptor){ // Execute saved object directly
      angular.forEach(descriptor.queries,function(query){
        chartCharacter.tables++
        angular.forEach(query.statistics,function(stat){
          if(!stat.match(/Count$/)){chartCharacter.nonCountStats++}
        })
        $scope.execute1anl(query,chartCharacter,obj)
      })
    } else {  // Execute from edit tree
      $scope.queries=[]

      angular.forEach($scope.data,function(node){
        if (node.scope){  // Tidy up the tree
          node.scope.collapse()
        }
      })
      if ($scope.anlGrps.grouping<0) {
        $scope.grphLoading=false
        $scope.formError='You must select the data to analyse by'
        return
      }   
      var grp=$scope.anlGrps.groupings[$scope.anlGrps.grouping]    
      if(!$scope.chartObject.chartTitle){$scope.chartObject.chartOptions.title.text = 'Analysis by '+grp.replace('_',' ')}
      var i=grp.indexOf('_')
      var grpTbl=grp.substr(0,i)
      var grpFld=grp.substr(i+1)
      var statCnt=0
      angular.forEach($scope.anlStats.nodes,function(tbl){
        var xTbl=$scope.tableMap[tbl.caption]
        if (tbl.caption==grpTbl || (xTbl.joinedTables && xTbl.joinedTables.indexOf(grpTbl)>=0) || (xTbl.commonGroupings && xTbl.commonGroupings.indexOf(grpFld)>=0)) {
          var stats=[], dds=[]
          angular.forEach(tbl.statistics,function(val,key){
            if (val) {
              if(!key.match(/Count$/)){chartCharacter.nonCountStats++}
              stats.push(key)
              statCnt++
            }
          })
          angular.forEach(tbl.drilldowns,function(val,key){
            if (val) {
              dds.push(key)
            }
          })
          if (stats.length){
            chartCharacter.tables++
            if (xTbl.commonGroupings && xTbl.commonGroupings.indexOf(grpFld)>=0) {
              grp=tbl.caption+'_'+grpFld   // Use the same named field in THIS table
            }
            var split=tbl.grouping?tbl.groupings[tbl.grouping]+',':''  
            var query={table:tbl.caption,statistics:stats,grouping:split+grp,filters:$scope.cleanFilterValue(tbl.filters),drilldowns:dds}
            $scope.queries.push(query)
            $scope.execute1anl(query,chartCharacter)
          }
        }
        })
      if (!statCnt) {
        $scope.grphLoading=false
        $scope.formError='You must select some statistics'
      }
      
    }
  }
      
  $scope.execute1anl=function(tblSpec,chartCharacter,obj){
    var ix=obj?obj.index:''
    var target='grphData'+ix+'_'+tblSpec.table  // Temporary target for fetch
    var query='table='+eu(tblSpec.table)+'&statistics='+eu(tblSpec.statistics.join())+'&grouping='+eu(tblSpec.grouping) + '&filters='+eu(JSON.stringify(tblSpec.filters))
    return $scope.fetch({fetchAPI:'olap/graphdata?'+query,fetchTarget:target,multiRow:true})
    .then(function(){
      if (tblSpec.grouping.indexOf(',')>=0){
        $scope.graph1anlSplit(tblSpec,$scope[target],chartCharacter,obj)
      } else {
        $scope.graph1anl(tblSpec,$scope[target],chartCharacter,obj)
      }
      $scope[target]=undefined  // Free temporary memory
      })
  }
  
  $scope.graph1anl=function(tblSpec,dat,chartCharacter,obj){
    var scope=obj?obj:$scope
    var chartObject=scope.chartObject
    if(!(dat && dat.length)){ // No result rows
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table
      return
    }
    var head=dat[0]
    var stats=[]
    angular.forEach(head,function(val,key){  // Go through the fields creating the datasets (one per statistic)
      if (key != 'Timing' && key != 'Grouping') {
        var cargo={query:tblSpec}
        var ds={label:key.replace(/[-_]/g,' '), borderWidth:1, hoverBorderWidth:2, data:[], _iqx_data_:cargo}
        stats.push({id: key, ds: ds})
        chartObject.chartData1.datasets.push(ds)
      }
      })
    if (chartObject.chartData1.datasets.length>10) {  // Hangs if a complex legend is drawn on the right
      chartObject.chartOptions.legend.position='bottom'
      }
    if (!stats.length) { // No stats
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table
      return
    }
    
    angular.forEach(dat,function(row){  // Go through the rows
      var catVal=row.Grouping || 'None'
      var i=chartObject.chartData1.labels.indexOf(catVal)
      if (i<0){  // Add new category to the graphh
        chartObject.chartData1.labels.push(catVal)
        i=chartObject.chartData1.labels.length-1
      } 
      angular.forEach(stats,function(stat){  
        while (stat.ds.data.length<i+1){  // Ensure dataset is long enough for this category value
          stat.ds.data.push(0)
        }
        stat.ds.data[i]=row[stat.id]  // Inject the stat in the right category
        })
      })
    scope.grphLoading=false
    chartObject.chartData=chartObject.chartData1
  }
  
  $scope.graph1anlSplit=function(tblSpec,dat,chartCharacter,obj){  // Alternative version for when a split is specified
    function makeLabel(splitVal,stat){
      stat=stat.replace(/[-]/g,' ')
      var res=splitVal
      var i=stat.indexOf('_')
      var tbl=stat.substr(0,i)
      stat=stat.substr(i+1)
      if(chartCharacter.tables>1){res=res+' '+tbl}
      if(chartCharacter.nonCountStats){res=res+' '+stat}
      return res.trim()
    }
    var scope=obj?obj:$scope
    var chartObject=scope.chartObject
    if(!(dat && dat.length)){ // No result rows
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table
      return
    }
    var head=dat[0]
    var stats=[]
    angular.forEach(head,function(val,key){  // Go through the fields finding the statistics
      if (key != 'Timing' && key != 'Grouping' && key != 'Split') {
        stats.push({id: key})
      }
      })
    if (!stats.length) { // No stats
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table
      return
    }
    
    var splitCheck=''  
    angular.forEach(dat,function(row){  // Go through the rows
      var splitVal=row.Split || 'None'
      if (splitVal != splitCheck){
        splitCheck=splitVal
        angular.forEach(stats,function(stat){
          var cargo={query:tblSpec}
          cargo.splitValue=splitVal
          var ds={label:makeLabel(splitVal,stat.id), borderWidth:1, hoverBorderWidth:2, data:[], _iqx_data_:cargo}
          stat.ds=ds
          chartObject.chartData1.datasets.push(ds)
          if (chartObject.chartData1.datasets.length>10) {  // Hangs if a complex legend is drawn on the right
            chartObject.chartOptions.legend.position='bottom'
          }
        })
      }
      var catVal=row.Grouping || 'None'
      var i=chartObject.chartData1.labels.indexOf(catVal)
      if (i<0){  // Add new category to the graphh
        chartObject.chartData1.labels.push(catVal)
        i=chartObject.chartData1.labels.length-1
      } 
      angular.forEach(stats,function(stat){  
        while (stat.ds.data.length<i+1){  // Ensure dataset is long enough for this category value
          stat.ds.data.push(0)
        }
        stat.ds.data[i]=row[stat.id]  // Inject the stat in the right category
        })
      })
    scope.grphLoading=false
    chartObject.chartData=chartObject.chartData1
  }
  
// Create Performance Chart
  
  $scope.executePerformance=function(obj){
    var scope=obj?obj:$scope
    var chartObject=scope.chartObject
    var descriptor=obj?obj.Descriptor:$scope.theRecord.Descriptor
    var chartCharacter={tables:0,nonCountStats:0}  // chartCharacter determines whether table names and stat names appear on the legend
    scope.formError=''
    chartObject.chartData = undefined
    chartObject.chartData1 = {datasets: []}
    chartObject.axisValue.display=false
    chartObject.axisCount.display=false
    chartObject.axisCount.position='left'
    chartObject.chartOptions.scales= {
      xAxes: [chartObject.axisTime],
      yAxes: [chartObject.axisValue, chartObject.axisCount]
    }
    if($window.innerWidth<1028){
      chartObject.chartOptions.legend.position='bottom'
    }
    scope.grphLoading=true
    if(descriptor){ // Execute saved object directly
      angular.forEach(descriptor.queries,function(query){
        chartCharacter.tables++
        angular.forEach(query.statistics,function(stat){
          if(!stat.match(/Count$/)){chartCharacter.nonCountStats++}
        })
        $scope.execute1perf(query,descriptor.range,descriptor.granularity,chartCharacter,obj)
      })
    } else {  // Execute from edit tree
      if(!$scope.chartObject.chartTitle){$scope.chartObject.chartOptions.title.text=''}
      $scope.queries=[]
      var statCnt=0
      angular.forEach($scope.data,function(tbl){
        if (tbl.scope){  // Tidy up the tree
          tbl.scope.collapse()
        }
        var stats=[], dds=[]
        angular.forEach(tbl.statistics,function(val,key){
          if(val){
            if(!key.match(/Count$/)){chartCharacter.nonCountStats++}
            stats.push(key)
            statCnt++
            }
        })
        angular.forEach(tbl.drilldowns,function(val,key){
          if (val) {
            dds.push(key)
          }
        })
        if (stats.length){
          chartCharacter.tables++
          var query={table:tbl.caption,timing:tbl.object.timings[tbl.timing],statistics:stats,grouping:tbl.groupings[tbl.grouping],filters:$scope.cleanFilterValue(tbl.filters),drilldowns:dds}
          $scope.queries.push(query)
          $scope.execute1perf(query,$scope.dateSelection.range.id,$scope.dateSelection.granularity.id,chartCharacter)
        }
      })
      if (!statCnt) {
        $scope.grphLoading=false
        $scope.formError='You must select some statistics'
      }
    }
  }
  
  $scope.execute1perf=function(tblSpec,range,granularity,chartCharacter,obj){
    var ix=obj?obj.index:''
    var target='grphData'+ix+'_'+tblSpec.table  // Temporary target for fetch
    var qRange
    if (angular.isString(range)){
      qRange='&range=' + eu(range)
    } else {
      qRange='&timefrom=' + eu(moment(range.timeFrom).format('YYYY-MM-DD'))
      qRange+='&timeto=' + eu(moment(range.timeTo).format('YYYY-MM-DD'))
    }
    var query='table=' + eu(tblSpec.table) + '&statistics=' + eu(tblSpec.statistics.join()) + '&timing=' + eu(tblSpec.timing) + '&grouping=' +eu(tblSpec.grouping) + qRange + '&granularity=' + eu(granularity) + '&filters='+eu(JSON.stringify(tblSpec.filters))
    return $scope.fetch({fetchAPI:'olap/graphdata?'+query,fetchTarget:target,multiRow:true})
    .then(function(){
      $scope.graph1perf(tblSpec,range,granularity,$scope[target],chartCharacter,obj)
      $scope[target]=undefined  // Free temporary memory
      })
  }
  
  $scope.graph1perf=function(tblSpec,range,granularity,dat,chartCharacter,obj){
    function makeLabel(grp,stat){
      stat=stat.replace(/[-]/g,' ')
      var res=grp
      var i=stat.indexOf('_')
      var tbl=stat.substr(0,i)
      stat=stat.substr(i+1)
      if(chartCharacter.tables>1){res=res+' '+tbl}
      if(chartCharacter.nonCountStats || !grp){res=res+' '+stat}
      return res.trim()
    }
    var scope=obj?obj:$scope
    var chartObject=scope.chartObject
    if(!(dat && dat.length)){ // No result rows
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table+' in specified date range'
      return
    }
    var head=dat[0]
    var stats=[]
    var grp=tblSpec.grouping
    if (grp=='None'){
      grp=''
    }
    angular.forEach(head,function(val,key){  // Go through the fields picking out the stats and deciding on Y axes
      if (key != 'Timing' && key != 'Grouping') {
        stats.push({id:key})
        if (key.match(/Count$/)){
          chartObject.axisCount.display=true
        } else {
          chartObject.axisValue.display=true
          chartObject.axisCount.position='right'  // If the count axis is also required it will now be on the right
        }
      }
      })
    if (!stats.length) { // No stats
      scope.grphLoading=false  // Otherwise 'Querying database' message gets stuck
      scope.formError='No matching data for '+tblSpec.table+' in specified date range'
      return
    }
    var grpCheck=''
    angular.forEach(dat,function(row){  // Go through the rows
      if (!stats[0].ds || (grp && row['Grouping']!=grpCheck)) {  // First row or, if has a group, change of group value
        grpCheck=row['Grouping']
        angular.forEach(stats,function(stat){  // Create new dataset and attach it
          var cargo={query:tblSpec, range:range, granularity:granularity}
          if(grp){cargo.groupingValue=row['Grouping'] || 'None'}
          stat.ds={label:makeLabel(grp?(row['Grouping'] || 'None')+' ':'',stat.id), yAxisID:(stat.id.match(/Count$/)?'Count':'Value'), data:[],_iqx_data_:cargo}
          chartObject.chartData1.datasets.push(stat.ds)
          })
        if (chartObject.chartData1.datasets.length>10) {  // Hangs if a complex legend is drawn on the right
          chartObject.chartOptions.legend.position='bottom'
          }
        }
      angular.forEach(stats,function(stat){  // Go through the stats and add value with date to the relevant dataset
        stat.ds.data.push({x:ApiSvc.StringToDate(row.Timing),y:row[stat.id]})
        })
      })
    if (chartObject.chartOptions.title.text && !chartObject.chartTitle){   // Prepare a title
      chartObject.chartOptions.title.text+=', '
    }
    scope.grphLoading=false
    if(!chartObject.chartTitle){chartObject.chartOptions.title.text+=tblSpec.table + (grp?' by '+grp.replace('_',' '):'')}
    chartObject.chartData=chartObject.chartData1
  }

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  
  $scope.tablePluralCaption=function(tbl){
    var res=''
    angular.forEach($scope.dictionary,function(t){
      if(t.table==tbl){
        res=t.plural || t.table+'s'
        }
    })
    return res
  }

  $scope.$on('chart-click',function(e,chart,evt){
    var els=chart.getElementAtEvent(evt)
    if(!(angular.isArray(els) && els.length)){return}
    var el=els[0]
    $scope.menuitems=[{caption:'List',action:'list',element:el}]

    var dsIndex=el._datasetIndex
    var iqx_data=el._chart.config.data.datasets[dsIndex]._iqx_data_
    var tblSpec=iqx_data.query
    angular.forEach(tblSpec.drilldowns,function(ddID){
      var dd=$scope.findDrilldown(ddID)
      if (dd){
        $scope.menuitems.push({caption:dd.Title,action:'chart',element:el,drilldown:dd})
      }
    })
    $scope.$apply()  // Required to make the displayed menu update
    $scope.menushow(evt)
  })
  
  function forceTablePrefix(fld,tbl){
    if(fld.indexOf('_')>0){ // Already contains table prefix 
      return fld
    } else {
      return tbl+'_'+fld
    }
  }
  
  $scope.drillDownChart=function(el,dd){
    var obj=angular.copy(dd)
    var ddDescrip=JSON.parse(obj.Descriptor)
    var dsIndex=el._datasetIndex
    var pointIndex=el._index
    var iqx_data=el._chart.config.data.datasets[dsIndex]._iqx_data_
    var tbl=iqx_data.query.table
    var point=el._chart.config.data.datasets[dsIndex].data[pointIndex]
    $scope.filterIX=($scope.filterIX || 0) + 1
    var filterPrefix='X'+$scope.filterIX+'_'  // To avoid colliding with dd report's own filters
    var ddCaption=obj.Title
    var queries=[]
    angular.forEach(ddDescrip.queries,function(qry){
      if(qry.table==tbl){
        queries.push(qry)
      }
    })
    angular.forEach(queries,function(qry){
      qry.filters=qry.filters || {}
      var grp=iqx_data.query.grouping || ''
      var i=grp.indexOf(',')
      if (i>=0) {
        if(iqx_data.splitValue){
          qry.filters[filterPrefix+forceTablePrefix(grp.substr(0,i),tbl)]={
            type:'DrillDownGroup',
            textValue:iqx_data.splitValue
          }
          ddCaption+=' - '+iqx_data.splitValue
        }
        grp=grp.substr(i+1)
      }
      if (grp) {
        var grpVal=iqx_data.groupingValue || el._chart.config.data.labels[pointIndex]
        if(grpVal){
          qry.filters[filterPrefix+forceTablePrefix(grp,tbl)]={
            type:'DrillDownGroup',
            textValue:grpVal
          }
          ddCaption+=' - '+grpVal
        }
      }
      
      if(angular.isObject(point) && angular.isDate(point.x)) { 
        var timeFrom=moment(point.x).format('YYYY-MM-DD')
        var timeTo=moment($scope.endOfRange(point.x,iqx_data.granularity)).format('YYYY-MM-DD')
        if(obj.Type=='Analysis Chart'){
          qry.filters[filterPrefix+forceTablePrefix(iqx_data.query.timing,tbl)]={
            type:'DrillDownTiming',
            timeFrom:timeFrom,
            timeTo:timeTo,
            //range:iqx_data.range,
            //granularity:iqx_data.granularity
          }
        } else {  // Performance Chart
          ddDescrip.range={timeFrom:timeFrom,timeTo:timeTo}
          ddDescrip.granularity=$scope.zoomGranularity(iqx_data.granularity)
        }
        ddCaption+=' - '+moment(point.x).format('DD/MM/YYYY')
      }
      
      // Add any filters from the calling chart
      angular.forEach(iqx_data.query.filters,function(val,key){
        if(!key.match(/^X\d+_/)){
          key=filterPrefix+key   // Don't use the native names to avoid conflicts
        }
        qry.filters[key]=val
      })

    })

    ddDescrip.queries=queries
    obj.Descriptor=ddDescrip
    
    $scope.setupChartOptions(obj)
    obj.chartObject.index='DDX'  // Used to create unique targets for fetch data
    $scope.execute(obj)

    FormSvc.modalInfo($scope,'drillDownChart',{object:obj, caption:ddCaption, choices:[{desc:"Close",type:"primary",code:''}]}, 'lg')
  }
  
  $scope.drillDownList=function(el){
    var dsIndex=el._datasetIndex
    var pointIndex=el._index
    var iqx_data=el._chart.config.data.datasets[dsIndex]._iqx_data_
    var tblSpec=iqx_data.query
    var sCaption=''
    var query='table='+eu(tblSpec.table)+'&filters='+eu(JSON.stringify(tblSpec.filters))
    var point=el._chart.config.data.datasets[dsIndex].data[pointIndex]
    if(angular.isObject(point) && angular.isDate(point.x)) {  // Performance
      query=query+'&timing='+eu(tblSpec.timing)
      var qRange
        qRange='&timefrom=' + eu(moment(point.x).format('YYYY-MM-DD'))
        qRange+='&timeto=' + eu(moment($scope.endOfRange(point.x,iqx_data.granularity)).format('YYYY-MM-DD'))
      
      query=query+qRange
      if(iqx_data.groupingValue){
        query=query+'&grouping='+eu(tblSpec.grouping)
        query=query+'&groupingvalue='+eu(iqx_data.groupingValue)
        sCaption+=' - '+iqx_data.groupingValue
      }
      sCaption+=' - '+moment(point.x).format('DD/MM/YYYY')
    } else if(isNumeric(point)){  // Analysis
      var grpVal=el._chart.config.data.labels[pointIndex]
      query=query+'&grouping='+eu(tblSpec.grouping) 
      query=query+'&groupingvalue='+eu(grpVal)
      sCaption+=' - '+grpVal
      if(iqx_data.splitValue){
        query=query+'&splitvalue='+eu(iqx_data.splitValue)
        sCaption+=' - '+iqx_data.splitValue
      }
    } else {
      return
    }
    return $scope.fetch({fetchAPI:'olap/drilldowndata?'+query,fetchTarget:'drillDownData',multiRow:true})
    .then(function(){
      return $scope.fetchDictionary()   // Fetches dictionary if not already fetched. Required for $scope.tablePluralCaption
    })
    .then(function(){
      if(!(angular.isArray($scope.drillDownData) && $scope.drillDownData.length)){return}
      sCaption=$scope.tablePluralCaption(tblSpec.table)+sCaption
      var sHead='',sBody='',sClass
      angular.forEach($scope.drillDownData[0],function(val,key){
        sClass=(key.substr(0,1)=='_')?' class="textright"':''
        sHead+='<th'+sClass+'>'+key.replace('_',' ')+'</th>'
        sBody+='<td'+sClass+'>{{row[\''+key+'\']}}</td>'
      })
      var sHTML='<div class="modal-header"><h3 class="modal-title">'+sCaption+'</h3></div><div class="modal-body">'
      sHTML+='<table class="table table-condensed"><thead><tr>'+sHead+'</tr></thead><tbody><tr ng-repeat="row in data.rows">'+sBody+'</tr></tbody></table>'
      sHTML+='<button class="btn btn-block btn-primary" ng-click="$close()">Close</button></div>'
      var data={rows:$scope.drillDownData}
      return FormSvc.modalInfo($scope,sHTML,data,'lg')
    })
    .finally(function(){
      $scope.drillDownData=undefined  // Free memory
    })
  }
  
  function workViewOffsets(){
    var rv={left:0,top:0}
    var el=document.querySelector('header.main-header')
    if (el){rv.top=el.offsetHeight}
    if (window.innerWidth>=768){
      el=document.querySelector('section.sidebar')
      if (el){rv.left=el.offsetWidth}
    }
    rv.left+=20
    rv.top+=20
    return rv
  }

  $scope.menushown=false
  
  $scope.menuitems=[]
  
  $scope.clickmenuitem=function(it){
    switch(it.action) {
      case 'list':
        $scope.drillDownList(it.element)
        break
      case 'chart':
        $scope.drillDownChart(it.element,it.drilldown)
        break
    }
  }
   
  $scope.menushow=function(evt){
      if ($scope.menushown) {return} // click will bubble up to the document and trigger menuhide
      evt.stopPropagation()  // prevent bubble up from immediately hiding the menu
      var offsets = workViewOffsets()
      var el=angular.element(document.getElementById('chartDropDown'))
      el.css({display:'block',left:evt.pageX-offsets.left+'px',top:evt.pageY-offsets.top+'px',position:'absolute',cursor:'pointer'})
      $document.on('click',$scope.menuhide)  // attach menuhide to document click so that a click anywhere will hide the menu 
      $scope.menushown=true
    }
    
  $scope.menuhide=function(evt){
      var el = angular.element(document.getElementById('chartDropDown'))
      el.css({display:'none'})
      $document.off('click',$scope.menuhide)  // remove the event from document click
      $scope.menushown=false
    }

  let returnToDashboard = () => {
    return ApplicationSvc.navigate('/dashboard?action=dashboard')
  }
  
  //Initialisation:
  FormSvc.setOptions($scope,{autoEdit:true})
  
  $scope.action=$routeParams.action || 'dashboard'
  
  if($scope.action=='list'){
    toastSvc.error('Action disabled', 'Please use iqx.exe to manage the analytics', 'nodesigner')
    returnToDashboard()
  } else if($scope.action=='design'){
    toastSvc.error('Action disabled', 'Please use iqx.exe to manage the analytics', 'nodesigner')
    returnToDashboard()

  } else if($scope.action=='display') {
      if($routeParams.object){
        $scope.fetch({fetchAPI:'callresult/NetDashboardObjects?pDashboardObjectID='+encodeURIComponent($routeParams.object)})
        .then(function(){
          return $scope.fetchDrilldowns()
        })
        .then(function(){
          $scope.createChartDefaults()
          $scope.setupChartOptions()
          $scope.execute()
        })
      } else {
        $scope.formError='No object specified'
      }
  } else if($scope.action=='dashboard') {
      $scope.fetch({fetchAPI:'callresult/NetDashboardObjects?pDashboard=1',multiRow:true})
      .then(function(){
        return $scope.fetchDrilldowns()
      })
      .then(function(){
        $scope.createChartDefaults()
        var ix=1
        angular.forEach($scope.theRecords,function(obj){
          $scope.setupChartOptions(obj)
          obj.chartObject.index=ix++  // Used to create unique targets for fetch data
          $scope.execute(obj)
        })
      })
  }
  
})